<section>
  <div class="container py-2 mb-5">
    <div class="card p-3">
      <form [formGroup]="addWorksheetEntryForm" (ngSubmit)="onSubmit()">
        <!-- Date input aligned right -->
        <div class="row mb-3">
          <div class="col-12 col-md-4 col-lg-3">
            <div class="form-floating">
              <input type="date" class="form-control" formControlName="entryDate" placeholder="Select a date"
                [max]="today"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('entryDate')?.invalid && addWorksheetEntryForm.get('entryDate')?.touched,
              'is-valid': addWorksheetEntryForm.get('entryDate')?.valid && addWorksheetEntryForm.get('entryDate')?.touched}" />
              <label for="dateInput">Date <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.entryDate">{{worksheetEntryFormErrors.entryDate}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="batchNumber"
                placeholder="Enter batch string number" [readOnly]="this.isReadOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('batchNumber')?.invalid && addWorksheetEntryForm.get('batchNumber')?.touched,
              'is-valid': addWorksheetEntryForm.get('batchNumber')?.valid && addWorksheetEntryForm.get('batchNumber')?.touched}" />
              <label for="totalTickets">Batch Number<span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.batchNumber">{{worksheetEntryFormErrors.batchNumber}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="pageStartingNumber"
                placeholder="Enter page starting number" [readOnly]="this.isReadOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('pageStartingNumber')?.invalid && addWorksheetEntryForm.get('pageStartingNumber')?.touched,
              'is-valid': addWorksheetEntryForm.get('pageStartingNumber')?.valid && addWorksheetEntryForm.get('pageStartingNumber')?.touched}" />
              <label for="totalTickets">Page Starting Number<span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.pageStartingNumber">{{worksheetEntryFormErrors.pageStartingNumber}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="pageEndingNumber"
                placeholder="Enter page ending number" [readOnly]="this.isReadOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('pageEndingNumber')?.invalid && addWorksheetEntryForm.get('pageStartingNumber')?.touched,
              'is-valid': addWorksheetEntryForm.get('pageEndingNumber')?.valid && addWorksheetEntryForm.get('pageEndingNumber')?.touched}" />
              <label for="totalTickets">Page Ending Number<span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.pageEndingNumber">{{worksheetEntryFormErrors.pageEndingNumber}}</span>
          </div>
        </div>

        <!-- Three inputs row with small space, aligned start, and some padding -->
        <div class="row mb-3 gx-2 px-2">
          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="totalImageCount"
                (input)="enteredTotalImage($event)" placeholder="Enter total given images"
                (keypress)="numberOnly($event)" [readOnly]="this.isReadOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('totalImageCount')?.invalid && addWorksheetEntryForm.get('totalImageCount')?.touched,
              'is-valid': addWorksheetEntryForm.get('totalImageCount')?.valid && addWorksheetEntryForm.get('totalImageCount')?.touched}" />
              <label for="totalTickets">Total Given Images <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.totalImageCount">{{worksheetEntryFormErrors.totalImageCount}}</span>
          </div>

          <!-- <div class="col-12 col-md-4 col-lg-3 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="anyAddedImageCount"
                (input)="addedImageCount($event)" placeholder="Enter any added image count"
                (keypress)="numberOnly($event)" [readOnly]="this.isCountReadyOnly" />
              <label for="anyAddedImageCount">Any Added Image Count</label>
            </div>
          </div> -->

          <div class="col-12 col-md-4 col-lg-3 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="noOfImagesCompleted"
                placeholder="Enter completed images" (input)="OnCalculate($event)" (keypress)="numberOnly($event)"
                [readOnly]="this.isCountReadyOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('noOfImagesCompleted')?.invalid && addWorksheetEntryForm.get('noOfImagesCompleted')?.touched,
              'is-valid': addWorksheetEntryForm.get('noOfImagesCompleted')?.valid && addWorksheetEntryForm.get('noOfImagesCompleted')?.touched}" />
              <label for="completedCount">Completed Images <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.noOfImagesCompleted">{{worksheetEntryFormErrors.noOfImagesCompleted}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="availableCount" placeholder="Enter pending images"
                (keypress)="numberOnly($event)" readonly
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('availableCount')?.invalid && addWorksheetEntryForm.get('availableCount')?.touched,
              'is-valid': addWorksheetEntryForm.get('availableCount')?.valid && addWorksheetEntryForm.get('availableCount')?.touched}" />
              <label for="pendingCount">Pending Images <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.availableCount">{{worksheetEntryFormErrors.availableCount}}</span>
          </div>

        </div>



        <div class="row mb-3 gx-2 px-2">

          <div class="col-md-4 col-lg-3 col-12 mb-2">
            <div class="form-group" style="border-radius: 5px !important; border: 1px solid">
              <label class="ms-2">On Leave?<span class="text-danger">*</span></label>
              <br />
              <div class="form-check form-check-inline ms-2">
                <input class="form-check-input" type="radio" formControlName="isLeave" [value]="true"
                  (change)="onSelectLeaveStatus(true)" />
                <label class="form-check-label">Yes</label>
              </div>
              <div class="form-check form-check-inline ms-2">
                <input class="form-check-input" type="radio" formControlName="isLeave" [value]="false"
                  (change)="onSelectLeaveStatus(false)" />
                <label class="form-check-label">No</label>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-lg-3 col-12 mb-2">
            <div class="form-group" style="border-radius: 5px !important; border: 1px solid">
              <label class="ms-2">Reassigned ?<span class="text-danger">*</span></label>
              <br />
              <div class="form-check form-check-inline ms-2">
                <input class="form-check-input" type="radio" formControlName="isAssigned" [value]="true"
                  (change)="onSelectAssignedStatus(true)" />
                <label class="form-check-label">Yes</label>
              </div>
              <div class="form-check form-check-inline ms-2">
                <input class="form-check-input" type="radio" formControlName="isAssigned" [value]="false"
                  (change)="onSelectAssignedStatus(false)" />
                <label class="form-check-label">No</label>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="assignCount"
                placeholder="Enter assign image count" (keypress)="numberOnly($event)" [readOnly]="isShowAddedImage"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('assignCount')?.invalid && addWorksheetEntryForm.get('assignCount')?.touched,
              'is-valid': addWorksheetEntryForm.get('assignCount')?.valid && addWorksheetEntryForm.get('assignCount')?.touched}" />
              <label for="assignCount">Assign Image Count<span class="text-danger"
                  *ngIf="addWorksheetEntryForm.get('isAssigned')?.value === true">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.assignCount">{{worksheetEntryFormErrors.assignCount}}</span>
          </div>

        </div>

        <div class="row gx-2 px-2">
          <div class="col-12 col-md-4 col-lg-3 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="noOfLinesTyped" placeholder="Enter total indexing"
                (keypress)="numberOnly($event)" (input)="OnCalculateIndexing()" [readOnly]="this.isCountReadyOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('noOfLinesTyped')?.invalid && addWorksheetEntryForm.get('noOfLinesTyped')?.touched,
              'is-valid': addWorksheetEntryForm.get('noOfLinesTyped')?.valid && addWorksheetEntryForm.get('noOfLinesTyped')?.touched}" />
              <label for="completedCount">Total Indexing / Images <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.noOfLinesTyped">{{worksheetEntryFormErrors.noOfLinesTyped}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="noExtractableData"
                placeholder="Enter no extractable data" (keypress)="numberOnly($event)" (input)="OnCalculateIndexing()"
                [readOnly]="this.isCountReadyOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('noExtractableData')?.invalid && addWorksheetEntryForm.get('noExtractableData')?.touched,
              'is-valid': addWorksheetEntryForm.get('noExtractableData')?.valid && addWorksheetEntryForm.get('noExtractableData')?.touched}" />
              <label for="noExtractableData">No Extractable & Administrative Images <span
                  class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.noExtractableData">{{worksheetEntryFormErrors.noExtractableData}}</span>
          </div>


          <div class="col-12 col-md-4 col-lg-3 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="accountableIndexing"
                placeholder="Enter accountable indexing" (keypress)="numberOnly($event)" readonly />
              <label for="accountableIndexing">Accountable Indexing / Images </label>
            </div>
          </div>

          <!-- <div class="col-12 col-md-4 col-lg-3 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="accountIndexingCost"
                placeholder="Enter accountable indexing count" (keypress)="numberOnly($event)" readonly />
              <label for="accountIndexingCost">Accountable Cost <span class="text-danger">*</span></label>
            </div>
          </div> -->
        </div>

        <!-- Save button centered -->
        <div class="row">
          <div class="col text-center">
            <button type="submit" class="btn btn-success px-4">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>